<template>
  <v-data-table
    :items="
      showDeleted
        ? getSuppliers
        : getSuppliers.filter(x => x.is_deleted === false)
    "
    item-key="id_fournisseur"
    :headers="headers"
    sort-by="name_fournisseur"
    :search="search"
    :mobile-breakpoint="0"
    hide-default-footer
    :items-per-page="$vuetify.breakpoint.xsOnly ? 8 : 10"
    @page-count="pageCount = $event"
    :page.sync="page"
  >
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-btn
          icon
          small
          @click="
            $router.push({
              name: 'SuppliersEditor',
              params: { id: item.id_fournisseur }
            })
          "
        >
          <v-icon small>far fa-edit</v-icon>
        </v-btn>
      </v-row>
    </template>
    <template v-slot:item.name_fournisseur="{ item }">
      <span class="font-capitalize notBorderRadiusfont-weight-bold">{{
        item.name_fournisseur
      }}</span>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SuppliersGrid",
  computed: {
    ...mapGetters(["getSuppliers"])
  },
  data() {
    return {
      showDeleted: false,
      search: "",
      page: 1,
      pageCount: 0,
      headers: [
        { value: "name_fournisseur", text: "Nom" },
        { value: "actions", text: "", sortable: false }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
